import { createFileRoute, redirect } from '@tanstack/react-router';

// Settings → Organization is the Team page; this URL stays for old links.
export const Route = createFileRoute('/settings/organization')({
  beforeLoad: () => {
    throw redirect({ to: '/settings/team' });
  },
});
